import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-token-expiry-dialog.component',
    templateUrl: './token-expiry-dialog.component.html',
    styleUrls: ['./token-expiry-dialog.component.scss'],
    standalone: false
})
export class TokenExpiryDialogComponent {

  constructor(private dialogRef: MatDialogRef<TokenExpiryDialogComponent>) { }

  close() {
    this.dialogRef.close();
  }
}
